import { Pipe, PipeTransform } from '@angular/core';
import { EditorCssClassConfig } from '../models/editor-css-class-config.model';

@Pipe({
  name: 'editorCssClass',
})
export class EditorCssClassPipe implements PipeTransform {
  transform(cssClass: string | EditorCssClassConfig | undefined, screen?: 'xl' | 'md' | 'lg' | 'sm' | 'xs'): string {
    if (!cssClass) {
      return '';
    }

    if (typeof cssClass === 'string') {
      return screen ? '' : cssClass;
    }

    const config: EditorCssClassConfig = cssClass as EditorCssClassConfig;
    return config[screen] || '';
  }
}
